import React, { FC } from 'react';
import { HtmlProps } from '../../atoms/Html';
import { PictureProps } from '../../atoms/Picture';
import * as SC from './styled';
export type InfographieBlockProps = MinimalSeoBlock & {
  className?: string;
  title?: string;
  anchor?: string;
  introduction?: HtmlProps;
  description?: HtmlProps;
  legend?: string;
  mobilePicture?: PictureProps;
  tabletPicture?: PictureProps;
  desktopPicture?: PictureProps;
};
const InfographieBlock: FC<InfographieBlockProps> = ({
  className,
  htmlTag,
  title,
  anchor,
  htmlTitleTag = 'h2',
  mobilePicture,
  tabletPicture,
  desktopPicture,
  introduction,
  description,
  legend
}) => {
  return <SC.Container className={className} as={htmlTag}>
      {introduction && <SC.Introduction {...introduction} />}
      {title && <SC.Title as={htmlTitleTag} id={anchor}>
          {title}
        </SC.Title>}
      {description && <SC.Description {...description} />}
      {(mobilePicture || tabletPicture || desktopPicture) && <SC.Figure>
          {mobilePicture && <SC.MobilePicture {...mobilePicture} maxWidth={600} />}
          {tabletPicture && <SC.TabletPicture {...tabletPicture} maxWidth={900} />}
          {desktopPicture && <SC.DesktopPicture {...desktopPicture} maxWidth={900} />}
        </SC.Figure>}
      {legend && <SC.Legend>{legend}</SC.Legend>}
    </SC.Container>;
};
export default InfographieBlock;